import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import bannerApi from 'api/bannerApi';
import KTFormSelect from 'general/components/OtherKeenComponents/Forms/KTFormSelect';
import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import AppResource from 'general/constants/AppResource';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';

DialogAddBannerView.propTypes = {
  banner: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogAddBannerView({ banner, onCancel, onDone }) {
  const [name, setName] = useState(banner?.name || '');
  const [position, setPosition] = useState(banner?.position || '');
  const [image, setImage] = useState(banner?.image || '');
  const [categoryId, setCategoryId] = useState(banner?.categoryId || '');
  const [link, setLink] = useState(banner?.link || '');
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    bannerApi.getBannerCategories({ limit: 1000 }).then(res => {
      if (res && res.data) {
        setCategoryList(res.data.data || []);
      }
    });
  }, []);

  const handleSubmit = async () => {
    setReadyToValidate(true);
    if (!Utils.isValid(name) || !Utils.isValid(image) || !Utils.isValid(categoryId) || !Utils.isValid(position)) {
      ToastHelper.showError('Vui lòng nhập đầy đủ thông tin bắt buộc');
      return;
    }
    
    const isUpdate = banner && banner.id;
    const currentData = { ...banner, name, image, categoryId, position, link };

    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        title={isUpdate ? 'Cập nhật' : 'Thêm mới'}
        contentEl={<>Bạn có chắc chắn muốn {isUpdate ? 'cập nhật' : 'thêm mới'} banner này không?</>}
        cancelButtonText="Bỏ qua"
        confirmButtonText="Đồng ý"
        onCancel={() => {
          AppCustomDialogHelper.show(
            isUpdate ? 'Chỉnh sửa banner' : 'Thêm mới banner',
            <DialogAddBannerView
              banner={currentData}
              onCancel={onCancel}
              onDone={onDone}
            />,
            'md', false, true, false, false
          );
        }}
        onConfirm={async () => {
          AppCustomDialogHelper.hide();
          try {
            setLoading(true);
            if (isUpdate) {
              await bannerApi.updateBanner(banner.id, { name, image, categoryId: parseInt(categoryId), position, link, status: banner.status });
              ToastHelper.showSuccess('Cập nhật banner thành công');
            } else {
              const params = {
                name,
                categoryId: parseInt(categoryId),
                position,
                image,
                link,
              };
              await bannerApi.createBanner({ ...params, status: 'ACTIVE' });
              ToastHelper.showSuccess('Thêm mới banner thành công');
            }
            if (onDone) onDone();
          } catch (error) {
            ToastHelper.showError(isUpdate ? 'Cập nhật banner thất bại' : 'Thêm mới banner thất bại');
          } finally {
            setLoading(false);
          }
        }}
        iconEl={<img src={AppResource.images.dialogIcons.dialogSuccess} />}
      />,
      'md', true, true
    );
  };

  return (
    <div>
      <div style={{ height: '50vh', overflowY: 'auto' }}>
        <div className="row m-0 p-0 px-2 mt-4">
          <div className="col-12 px-2 mb-4">
            <div>
              {UIHelper.buildFormLabel('Tên banner', true)}
              <KTFormInput
                type={KTFormInputType.text}
                placeholder="Nhập tên banner"
                name="name"
                value={name}
                onChange={(value) => setName(value)}
                enableCheckValid={readyToValidate}
                isValid={Utils.isValid(name)}
                isTouched={readyToValidate}
                feedbackText="Tên banner không được để trống"
              />
            </div>
          </div>
          <div className="col-12 px-2 mb-4">
            <div>
              {UIHelper.buildFormLabel('Vị trí', true)}
              <KTFormInput
                name="position"
                value={position}
                onChange={(value) => setPosition(value)}
                enableCheckValid={readyToValidate}
                isValid={Utils.isValid(position)}
                isTouched={readyToValidate}
                feedbackText="Vị trí không được để trống"
                placeholder="VD: banner_tong_quan, banner_don_hang..."
              />
            </div>
          </div>
          <div className="col-12 px-2 mb-4">
            <div>
              {UIHelper.buildFormLabel('Đường dẫn (URL điều hướng)')}
              <KTFormInput
                type={KTFormInputType.text}
                name="link"
                value={link}
                onChange={(value) => setLink(value)}
                placeholder="VD: https://cms.evgroup.com.vn hoặc /products/123"
              />
            </div>
          </div>
          <div className="col-12 px-2 mb-4">
            <div>
              {UIHelper.buildFormLabel('Danh mục', true)}
              <KTFormSelect
                name="categoryId"
                options={[{ value: '', name: 'Chọn danh mục' }, ...categoryList.map(c => ({ value: c.id, name: c.name }))]}
                value={categoryId}
                onChange={(value) => setCategoryId(value)}
              />
              {readyToValidate && !Utils.isValid(categoryId) && (
                <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                  Danh mục không được để trống
                </div>
              )}
            </div>
          </div>
          <div className="col-12 px-2 mb-4">
            <div>
              {UIHelper.buildFormLabel('Hình ảnh banner', true)}
              <KTImageInput
                name="image"
                acceptImageTypes={['image/png', 'image/jpeg', 'image/jpg', 'image/webp']}
                value={image}
                onChange={(url) => setImage(url)}
                removable={true}
                onRemovedFile={() => setImage('')}
                onForceRemoveFile={() => setImage('')}
                isUploadIdCard={true}
                aspectRatio="16/9"
                fullWidth={true}
              />
              {readyToValidate && !Utils.isValid(image) && (
                <div className="text-danger mt-1" style={{ fontSize: '13px' }}>
                  Hình ảnh không được để trống
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildGreenButton(banner ? 'Lưu' : 'Thêm', handleSubmit, null, false, loading)}
      </div>
    </div>
  );
}

export default DialogAddBannerView;
